// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__2SpXc","SidebarMode":"NavigationItem_SidebarMode__2lbPl"};